module.exports = __webpack_public_path__ + "static/media/Carousel Image 2.814ff006.png";